export const _deleteCommaSeparator = (value: string): string => {
    return value.replace(/,/g, '');
};